import {connect} from 'react-redux'

import {HistorySidebar} from './history_sidebar.component'


const mapStateToProps = (state) => {
    return {
        itineraryId: state.getIn(['document', 'properties', 'itineraryGuid']),
        history: state.get('history'),
        travelers: state.getIn(['document', 'travelers'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const HistorySidebarContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HistorySidebar)

export default HistorySidebarContainer
